export const skin = (() => {
    const placeHolderText = 'No rashes or suspicious moles.   '

    return placeHolderText
})